import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { portalApi, type TrackResult } from '@/api/auth';
import { publicRoutes } from '@/app/routes';
import { dt } from '@/shared/format';
import { SHIPMENT_STATUS_COLOR } from '@/shared/cargo';
import { StatusBadge } from '@/shared/ui/kit';

export function TrackPage() {
  const { trackingNo } = useParams();
  const [code, setCode] = useState(trackingNo ?? '');
  const [result, setResult] = useState<TrackResult | null>(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  async function search(tn: string) {
    if (!tn.trim()) return;
    setBusy(true);
    setErr('');
    setResult(null);
    try {
      setResult(await portalApi.track(tn.trim()));
    } catch {
      setErr('Илгээмж олдсонгүй. Track дугаараа шалгана уу.');
    } finally {
      setBusy(false);
    }
  }

  useEffect(() => {
    if (trackingNo) search(trackingNo);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trackingNo]);

  return (
    <div className="cg-auth-wrap" style={{ flexDirection: 'column', alignItems: 'stretch', maxWidth: 560, margin: '0 auto' }}>
      <div className="cg-brand" style={{ justifyContent: 'center', marginTop: 30 }}>
        <i className="bi bi-truck-front" /> TseTsu Карго
      </div>
      <div className="ts-card" style={{ padding: 22, marginTop: 12 }}>
        <h1 className="ts-page-title" style={{ marginBottom: 4 }}>Илгээмж хайх</h1>
        <p className="ts-page-sub" style={{ marginBottom: 16 }}>Track дугаараар илгээмжийнхээ явцыг хянаарай.</p>
        <div className="ts-flex-row">
          <input className="ts-input" placeholder="CG-20260526-001" value={code} onChange={(e) => setCode(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && search(code)} />
          <button className="ts-btn ts-btn-primary" disabled={busy} onClick={() => search(code)}><i className="bi bi-search" /></button>
        </div>
        {err && <div style={{ color: 'var(--ts-danger)', marginTop: 12 }}>{err}</div>}
      </div>

      {result && (
        <div className="ts-card" style={{ padding: 22, marginTop: 14 }}>
          <div className="ts-flex-between" style={{ marginBottom: 14 }}>
            <div>
              <div style={{ fontWeight: 800, fontSize: '1.15rem' }}>{result.TrackingNo}</div>
              <div className="ts-page-sub">{result.CompanyName}</div>
            </div>
            <StatusBadge label={result.StatusLabel} color={SHIPMENT_STATUS_COLOR[result.Status]} />
          </div>
          <div className="cg-timeline">
            {result.TrackingEvents.map((e) => (
              <div key={e.Id} className="cg-tl-item">
                <div className="cg-tl-dot" />
                <div>
                  <div style={{ fontWeight: 600 }}>{e.EventTypeLabel}</div>
                  <div className="ts-page-sub">{dt(e.OccurredOn)} {e.WarehouseName ? `· ${e.WarehouseName}` : ''}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      <div style={{ textAlign: 'center', marginTop: 18 }}>
        <Link to={publicRoutes.portalLogin} className="ct-link">Бүх илгээмжээ харах → нэвтрэх</Link>
      </div>
    </div>
  );
}
